import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { LANGUAGES, LANGUAGES_KEYS, LANGUAGES_VALUES } from "@constants/global.constants";

const LanguageSwitcher: React.FC = () => {
	const { i18n, t } = useTranslation();

	const handleLanguageChange = () => {
		const newLanguage = i18n.language === LANGUAGES_KEYS.en ? LANGUAGES_KEYS.ur : LANGUAGES_KEYS.en;
		i18n.changeLanguage(newLanguage);
		localStorage.setItem("preferredLanguage", newLanguage);
	};

	const currentLanguage = i18n.language === LANGUAGES_KEYS.en ? LANGUAGES_VALUES.en : LANGUAGES_VALUES.ur;

	return (
		<Tooltip title={t("common.language.switchLanguage") || "Switch Language"} arrow>
			<button
				onClick={handleLanguageChange}
				className="flex items-center gap-2 w-full px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors text-gray-900 font-medium"
				aria-label={`Switch to ${i18n.language === LANGUAGES_KEYS.en ? LANGUAGES.urdu : LANGUAGES.english}`}
			>
				<LanguageRoundedIcon color="success" />
				<span className="text-sm">{currentLanguage}</span>
			</button>
		</Tooltip>
	);
};

export default LanguageSwitcher;
